import ServerDataGrid from "../../../datagrid/ServerDataGrid";
import { columns } from "./columns";

export function HouseReceivedTablePage() {
  return (
    <ServerDataGrid
      initialStateOverride={{
        filter: {
          filterModel: {
            items: [{ field: "house.qty", operator: "<", value: 1 }],
          },
        },
      }}
      columns={columns}
      getRowId={(row) => row.house.id}
      apiEndpoint="/datagrid/house"
      tableName="house"
      enableCreate={false}
      enableSearch={true}
    />
  );
}
